import React from 'react';
import { realValues, isCategorizedSkills, splitSkill, validCerts, certMeta } from './contactUtils';

export default function ModernTemplate({ resume }) {
  if (!resume) return null;
  const c = resume.contact || {};

  return (
    <div style={{ fontFamily: '"Segoe UI", system-ui, -apple-system, sans-serif', maxWidth: '680px', margin: '0 auto', padding: '28px 32px', fontSize: '11px', lineHeight: '1.55', color: '#1a1a1a', background: '#fff' }}>
      {/* Header */}
      <div style={{ borderBottom: '2px solid #1d4ed8', paddingBottom: '10px', marginBottom: '14px' }}>
        <div style={{ fontSize: '24px', fontWeight: '700', color: '#1d4ed8', marginBottom: '4px' }}>{c.name}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', fontSize: '9.5px', color: '#555' }}>
          {realValues([c.email, c.phone, c.location, c.linkedin]).map((v, i) => (
            <span key={i}>{v}</span>
          ))}
        </div>
      </div>

      {resume.summary && (
        <Section title="PROFESSIONAL SUMMARY">
          <p style={{ margin: 0, color: '#333' }}>{resume.summary}</p>
        </Section>
      )}

      {resume.skills?.length > 0 && (
        <Section title="SKILLS">
          {isCategorizedSkills(resume.skills) ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', color: '#333' }}>
              {resume.skills.map((s, i) => {
                const { label, rest } = splitSkill(s);
                return <div key={i}>{label ? <><strong>{label}:</strong> {rest}</> : <>•&nbsp;{s}</>}</div>;
              })}
            </div>
          ) : (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
              {resume.skills.map((s, i) => (
                <span key={i} style={{ background: '#eff6ff', color: '#1d4ed8', borderRadius: '12px', padding: '2px 9px', fontSize: '9.5px', fontWeight: '500' }}>{s}</span>
              ))}
            </div>
          )}
        </Section>
      )}

      {resume.experience?.length > 0 && (
        <Section title="EXPERIENCE">
          {resume.experience.map((exp, i) => (
            <div key={i} style={{ marginBottom: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <span style={{ fontWeight: '700', fontSize: '11.5px' }}>{exp.company}</span>
                <span style={{ fontSize: '9px', color: '#666' }}>{exp.dates}</span>
              </div>
              <div style={{ color: '#1d4ed8', fontStyle: 'italic', fontSize: '10px', marginBottom: '4px' }}>{exp.title}</div>
              <ul style={{ margin: 0, paddingLeft: '14px' }}>
                {exp.bullets?.map((b, j) => (
                  <li key={j} style={{ marginBottom: '2px', color: '#333' }}>{b}</li>
                ))}
              </ul>
            </div>
          ))}
        </Section>
      )}

      {resume.education?.length > 0 && (
        <Section title="EDUCATION">
          {resume.education.map((edu, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <div>
                <span style={{ fontWeight: '600' }}>{edu.institution}</span>
                <span style={{ color: '#555', marginLeft: '6px' }}>{edu.degree}</span>
              </div>
              <span style={{ color: '#666', fontSize: '9.5px' }}>{edu.dates}</span>
            </div>
          ))}
        </Section>
      )}

      {validCerts(resume).length > 0 && (
        <Section title="CERTIFICATIONS">
          {validCerts(resume).map((cert, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <span style={{ fontWeight: '600' }}>{cert.name}</span>
              <span style={{ color: '#666', fontSize: '9.5px' }}>{certMeta(cert)}</span>
            </div>
          ))}
        </Section>
      )}
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '12px' }}>
      <div style={{ fontSize: '9px', fontWeight: '700', letterSpacing: '1.5px', color: '#1d4ed8', borderBottom: '1px solid #bfdbfe', paddingBottom: '3px', marginBottom: '7px', textTransform: 'uppercase' }}>{title}</div>
      {children}
    </div>
  );
}
